export default "__VITE_ASSET__DOsk3661__"